module.exports = __webpack_public_path__ + "static/media/women-fas-cat-2.6781f69a.png";